import MainLayout from "@/components/layouts";
import { useServiceSurveys } from "./survey.hooks";
import { useParams } from "react-router";
import { uuid } from "@/interfaces";
import { NoData } from "@/components/shared/no-data";
import { SurveyCard } from "./survey.components/survey-card";
import AddSurveyModal from "./survey.components/add-item";

export default function ServiceSurveys() {
  const { id } = useParams();
  const { list, loading, onSubmit, open, setOpen, onDelete } = useServiceSurveys(id as uuid);

  const layoutProps = {
    loading,
    pageHeader: {
      title: "Surveys",
      subtitle: "Manage your services surveys here",
      buttonText: "Add Survey Question",
      onButtonClick() {
        setOpen(true);
      },
    },
    breadcrumb: [
      {
        name: "Services",
        href: "/services",
      },
      {
        name: "Surveys",
        href: "#",
      },
    ],
  };

  return (
    <MainLayout {...layoutProps}>
      <div className="container mx-auto">
        {list.length === 0 && <NoData text="We couldnot find any survey for this service." />}
        <div className="flex flex-col gap-4">
          {list.map((task) => (
            <SurveyCard task={task} onDelete={onDelete} key={task.id} />
          ))}
        </div>
      </div>
      <AddSurveyModal
        {...{
          open,
          setOpen,
          onSubmit,
        }}
      />
    </MainLayout>
  );
}
